const collectionHandle =
  document.querySelector("body").dataset.collectionHandle;

function normalizeTags(tags) {
  if (tags == null) return [];
  if (Array.isArray(tags)) {
    return tags.map((t) => String(t).trim()).filter(Boolean);
  }
  if (typeof tags === "string") {
    return tags
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
  }
  return [];
}

/** Boost filter API payloads often omit or lag newly added tags; Shopify product JSON is canonical. */
async function mergeShopifyProductTags(product) {
  const handle = product.handle;
  if (!handle) {
    return { ...product, tags: normalizeTags(product.tags) };
  }
  try {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
    if (!res.ok) {
      return { ...product, tags: normalizeTags(product.tags) };
    }
    const data = await res.json();
    const shopifyTags = normalizeTags(data.tags);
    if (shopifyTags.length > 0) {
      return { ...product, tags: shopifyTags };
    }
  } catch (_) {
    /* keep Boost payload */
  }
  return { ...product, tags: normalizeTags(product.tags) };
}

async function createCollectionProductCard(product) {
  const p = await mergeShopifyProductTags(product);
  const productCard = document.createElement("product-card");
  productCard.className = "new-product-card !gap-4 font-bold";
  productCard.setAttribute("data-product-id", p.id);

  const url = collectionHandle
    ? `/collections/${collectionHandle}/products/${p.handle}`
    : `/products/${p.handle}`;

  productCard.innerHTML = `
      <a href="${url}" class="no-underline relative">
        ${createProductBadges(p)}
        ${createProductGallery(
          p.images_info.filter((image) => {
            if (image.alt) {
              return !image.alt.includes("ad-img");
            } else {
              return true;
            }
          })
        )}
      </a>

      <collection-product-card-info data-product-handle="${p.handle}">
        ${createProductTitle(p)}
        ${createPriceList(p)}
      </collection-product-card-info>
    `;
  return productCard;
}

window.createCollectionProductCard = createCollectionProductCard;


class CollectionProductCardInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productHandle = this.getAttribute("data-product-handle");
    this.init();
  }

  init() {
    fetch(`/products/${this.productHandle}?view=boost-item`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const productInfo = doc.querySelector("[data-product-info]");

        if (productInfo) {
          this.innerHTML = productInfo.innerHTML;
        }
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });
  }
}

if (!window.customElements.get("collection-product-card-info")) {
  customElements.define(
    "collection-product-card-info",
    CollectionProductCardInfo
  );
}

function createReviews(product) {
  return `<a
      class="reviewss no-underline"
      js-okereviews-link
      href="${product.url}">
    </a>`;
}

function escapeBadgeText(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function plpBadgeLabelFromTags(tags) {
  const list = normalizeTags(tags);
  if (!list.length) return "";
  const prefix = "plp-badge-";
  for (let i = 0; i < list.length; i++) {
    const t = String(list[i]).trim().toLowerCase();
    if (t.startsWith(prefix) && t.length > prefix.length) {
      const slug = t.slice(prefix.length);
      return slug
        .split("-")
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    }
  }
  return "";
}

function createProductBadges(product) {
  const tags = normalizeTags(product.tags);
  let badges = '<div class="product-card__badges font-normal h-fit">';

  if (!product.available) {
    badges += '<div class="product-card__badge primary">Sold Out</div>';
  }
  else if (tags.includes("Best Sellers Collection")) {
    badges += '<div class="product-card__badge primary">Best Seller</div>';
  }

  let secondaryBadgeContent = "";
  if (tags.includes("3 FOR 35% OFF")) {
    secondaryBadgeContent = "3 for 35% off";
  } else if (tags.includes("The Tee Shop")) {
    secondaryBadgeContent = "Bundle + Save";
  } else if (tags.includes("3 FOR 20% OFF")) {
    secondaryBadgeContent = "3 for 20% off";
  } else if (tags.includes("BUY 2 GET 1 FREE")) {
    secondaryBadgeContent = "Buy 2, Get 1 Free";
  } else if (tags.includes("take-back-bag")) {
    secondaryBadgeContent = "Buy 3+ and Get Free Shipping";
  } else if (tags.includes("Preorder")) {
    secondaryBadgeContent = "Preorder";
  } else if (tags.includes("BUY 3 PACKS GET 1 FREE")) {
    secondaryBadgeContent = "Buy 3 Packs, Get 1 Free";
  } else if (tags.includes("BUY 2 PACKS GET 1 FREE")) {
    secondaryBadgeContent = "Buy 2 Packs, Get 1 Free";
  }

  if (secondaryBadgeContent) {
    const badgeClass = secondaryBadgeContent
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
    badges += `<div class="product-card__badge secondary ${badgeClass}">${escapeBadgeText(secondaryBadgeContent)}</div>`;
  }

  const plpBadgeLabel = plpBadgeLabelFromTags(tags);
  if (plpBadgeLabel) {
    badges += `<div class="product-card__badge secondary bundle-save">${escapeBadgeText(plpBadgeLabel)}</div>`;
  }

  if (tags.includes("Preorder")) {
    badges += '<div class="product-card__badge secondary">Preorder</div>';
  }

  badges += "</div>";

  if (
    product.compare_at_price_min &&
    product.compare_at_price_min > product.price_min
  ) {
    const discount =
      Math.round(
        (((product.compare_at_price_min - product.price_min) /
          product.compare_at_price_min) *
          100) /
          5
      ) * 5;
    badges += `<div class="product-card__discount first-variant">${discount}% OFF</div>`;
  }

  return badges;
}
function createProductGallery(imagesInfo) {
  if (!imagesInfo || imagesInfo.length === 0) {
    return '<div class="product-card-gallery">No image available</div>';
  }

  let galleryHtml = `
    <product-card-gallery class="product-card-gallery">
      <div class="swiper flex max-w-full">
        <div class="swiper-wrapper product-card-gallery__slide">
  `;

  imagesInfo.forEach((image) => {
    galleryHtml += `
      <div class="swiper-slide">
        <div class="product-card-gallery__image-container">
          <img src="${image.src}" class="product-card-gallery__image" alt="${image.alt || ''}" />
        </div>
      </div>
    `;
  });

  galleryHtml += `
        </div>
        <div class="product-card-gallery__navigation">
          <div class="swiper-button-prev"></div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </product-card-gallery>
  `;

  return galleryHtml;
}

function createProductTitle(product) {
  const title = product.title || "Unknown Product";
  return `<a href="${
    product.url || "#"
  }" class="lg:px-2 font-visby text-[14px] leading-[1.2] text-black no-underline block">${title}</a>`;
}

function createQuickAdd(product) {
  return `
      <div class="quick-add-trigger">
        <button class="quick-add-button" data-quick-add-trigger>Quick Add</button>
      </div>
    `;
}

function createPriceList(product) {
  let priceHtml = '<div class="leading-tight mt-2 lg:px-2">';

  if (
    product.compare_at_price_min &&
    product.compare_at_price_min > product.price_min
  ) {
    priceHtml += `<span class="line-through">$${product.compare_at_price_min}</span>`;
    priceHtml += `<span class="text-red-500">$${product.price_min}</span>`;
  } else {
    priceHtml += `<span>$${product.price_min}</span>`;
  }

  priceHtml += "</div>";
  return priceHtml;
}

function createDesktopQuickAdd(product) {
  const formId = `desktop-quickadd-${product.id}`;
  const tagsDowncase = normalizeTags(product.tags).map((tag) =>
    tag.toLowerCase()
  );
  const options = product.options_with_values.map((option) => option.name);
  const variant = product.variants[0];
  const productMeta = {
    id: String(product.id),
    title: product.title || "",
    featured_image: product.featured_image || "",
    options: options.join(","),
    is_final_sale:
      tagsDowncase.includes("final sale") || tagsDowncase.includes("finalsale"),
  };
  return `
  <product-form class="contents">
  <form id="${formId}" method="post" action="/cart/add">
    ${
      tagsDowncase.includes("final sale") || tagsDowncase.includes("finalsale")
        ? `
      <input
        type="hidden"
        name="properties[Final Sale]"
        form="${formId}"
        value="Yes">
    `
        : ""
    }
  </form>
    <variant-picker class="variant-picker lg:px-2">
      <input
        type="hidden"
        name="id"
        value="${variant.id}"
        form="${formId}">
      ${createLinkedProducts(product)}
      <script data-variants type="application/json">
        ${JSON.stringify(product.variants || [])}
      </script>

      <script data-product type="application/json">
        ${JSON.stringify(productMeta)}
      </script>
      </variant-picker>
  </product-form>
    `;
}

function createLinkedProducts(product) {
  const colorCollectionTag = normalizeTags(product.tags)
    .find((tag) => tag.includes("color-collection:"))
    ?.split(":")[1]
    ?.trim();

  if (!colorCollectionTag) {
    return "";
  }

  const colorCollection = window.colorCollections?.[colorCollectionTag];
  if (!colorCollection || colorCollection.length === 0) {
    return "";
  }

  const colorOption = product.options_with_values.find(
    (option) => option.name === "Color"
  );
  const totalLinkedProducts = colorCollection.length;
  const limit = 3;

  let linkedProductsHTML = `
    <div class="flex items-center z-[4] flex-wrap" style="gap: 4px">
  `;

  colorCollection.forEach((colorProduct, index) => {
    const afterLimit = index >= limit;
    const isSelected = colorProduct.id === product.id;
    const colorProductOption = colorProduct.options_with_values?.find(
      (option) => option.name === "Color"
    );
    const colorValue = colorProductOption?.selected_value?.name || "";
    const colorImageUrl = `color-${colorValue
      .toLowerCase()
      .replace(/\s+/g, "-")}.png`;

    if (afterLimit) {
      return;
    }

    linkedProductsHTML += `
      <div
        class="linked-product-swatch ${isSelected ? "selected" : ""} ${
      afterLimit ? "after-limit" : ""
    }"
        data-linked-product-url="${colorProduct.url}"
        style="background-image: url('${colorImageUrl}');">
      </div>
    `;
  });

  if (totalLinkedProducts > limit) {
    linkedProductsHTML += `
      <div class="font-normal mb-1 after-limit-text">+${
        totalLinkedProducts - limit
      }</div>
    `;
  }

  linkedProductsHTML += "</div>";
  return linkedProductsHTML;
}
